export function offsetXYFromParentOf (evt) {
  const offsetParent = evt.target || document.body
  const offsetParentRect = evt.offsetParent === document.body ? {left: 0, top: 0} : offsetParent.getBoundingClientRect()

  const x = evt.dragEvent.clientX + offsetParent.scrollLeft - offsetParentRect.left
  const y = evt.dragEvent.clientY + offsetParent.scrollTop - offsetParentRect.top

  return {x, y}
}



// WEBPACK FOOTER //
// ./src/components/form/dragUtil.js